import styled from 'styled-components';
import { Skeleton as AntSkeleton } from 'antd';

export const Skeleton = styled(AntSkeleton)``;
